module.exports = __webpack_public_path__ + "static/media/power_supply_equipment.cd84108e.svg";